import { Box, Typography, useTheme } from '@mui/material';
import { IconType } from 'react-icons';
import { IoChevronForward } from 'react-icons/io5';

export type RequestCardProps = {
    icon: IconType;
    headline: string;
    description: string;
    attachmentCount: number;
    attachmentCountLabel: string;
    onClick: () => void;
};

const RequestCard = ({ icon: Icon, headline, description, attachmentCount, attachmentCountLabel, onClick }: RequestCardProps) => {
    const theme = useTheme();

    return (
        <Box
            onClick={onClick}
            sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: 2,
                padding: 2,
                border: 1,
                borderColor: 'divider',
                borderRadius: '8px',
                cursor: 'pointer',
                width: '100%',
                backgroundColor: theme.palette.background.default,
                transition: 'border-color 0.2s ease, background-color 0.2s ease',
                '&:hover': {
                    borderColor: theme.palette.primary.main,
                },
            }}
        >
            <Box sx={{ flexShrink: 0 }}>
                <Icon size={24} style={{ color: theme.palette.primary.main }} />
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    flex: 1,
                    gap: 0,
                    minWidth: 0, // Allow flex item to shrink below content size
                    overflow: 'hidden', // Prevent content from overflowing
                }}
            >
                <Typography variant="body1" color={theme.palette.text.primary} fontWeight={700}>
                    {headline}
                </Typography>
                <Typography
                    variant="body2"
                    fontSize={13}
                    lineHeight={1.4}
                    color="text.secondary"
                    sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        maxWidth: '100%',
                    }}
                >
                    {description}
                </Typography>
                {attachmentCount > 0 && (
                    <Typography variant="body2" lineHeight={1.4} fontSize={13} color="text.secondary">
                        {attachmentCountLabel}
                    </Typography>
                )}
            </Box>
            <Box sx={{ flexShrink: 0 }}>
                <IoChevronForward size={24} style={{ color: theme.palette.text.secondary }} />
            </Box>
        </Box>
    );
};

export default RequestCard;

